import React, { useEffect, useState } from "react";
import "./style.css";
import { Helmet } from "react-helmet";

import favicon from "../Assets/Favicon.png";
import Headers from "../Common/Headers";

import Post from "../../../Apis/backlink/Post";
import Get from "../../../Apis/backlink/Get";
import Put from "../../../Apis/backlink/Put";
import Delete from "../../../Apis/backlink/Delete";
import { getAPIUrlBM } from "../../../utils/config";
import sweetAlert from "sweetalert";
import { useLocation, useParams } from "react-router";
import RouteChecker from "../../utils/RouteChecker";
import EditIcon from "../Assets/EditIcon";
import Switch from "@mui/material/Switch";
import { Stack, Typography } from "@mui/material";

function AddUserApiKey() {
  const [checked, setChecked] = React.useState(true);

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  const [rows, setRows] = useState([
    { apiKey: "", dailyLimit: "", engine: "" },
    { apiKey: "", dailyLimit: "", engine: "" },
    { apiKey: "", dailyLimit: "", engine: "" },
    { apiKey: "", dailyLimit: "", engine: "" },
    { apiKey: "", dailyLimit: "", engine: "" },
  ]);
  const [userApiKeys, setUserApiKeys] = useState([]);
  const [rows2, setRows2] = useState([
    { apiKey: "", secret: "", token: "" },
    { apiKey: "", secret: "", token: "" },
    { apiKey: "", secret: "", token: "" },
    { apiKey: "", secret: "", token: "" },
    { apiKey: "", secret: "", token: "" },
  ]);

  const [rows3, setRows3] = useState([
    { apiKey: "", secret: "", token: "" },
    { apiKey: "", secret: "", token: "" },
    { apiKey: "", secret: "", token: "" },
    { apiKey: "", secret: "", token: "" },
    { apiKey: "", secret: "", token: "" },
  ]);

  const [edit2, setEdit2] = useState({});
  const locationParams = useLocation();
  // console.log(locationParams.state, "ankur chaurasia");
  const [tab, setTab] = useState(locationParams?.state?.tab ?? 1);
  const [userMojApiKeys, setUserMojApiKeys] = useState([]);
  useEffect(() => {
    getApiKey();
    getApiKey2();
  }, []);
  const getApiKey = async () => {
    try {
      const url = getAPIUrlBM();
      const response = await Get(url + "/get/user_api_key");
      console.log(response);
      setUserApiKeys(response.data);
    } catch (error) {
      console.log(error);
    }
  };
  const getApiKey2 = async () => {
    try {
      const url = getAPIUrlBM();
      const response = await Get(url + "/get/user_moj_api_key");
      console.log(response);
      setUserMojApiKeys(response.data);
    } catch (error) {
      console.log(error);
    }
  };
  const submitForm = async () => {
    try {
      // Filter out empty rows
      const filteredApiKeys = rows.filter(
        (apiKey) =>
          apiKey.apiKey !== "" ||
          apiKey.dailyLimit !== "" ||
          apiKey.engine !== "",
      );
      // give error if any row is incomplete
      const incompleteRows = filteredApiKeys.filter(
        (apiKey) =>
          apiKey.apiKey === "" ||
          apiKey.dailyLimit === "" ||
          apiKey.engine === "",
      );
      if (incompleteRows.length > 0) {
        // setError("Error: Please enter complete row");
        sweetAlert("Error", "Please enter complete row", "error");
        return;
      }
      // give error if no api keys are entered
      if (filteredApiKeys.length === 0) {
        // setError("Error: Please enter at least one complete row");
        sweetAlert("Error", "Please enter at least one complete row", "error");
        return;
      }
      const url = getAPIUrlBM();
      const response = await Post(url + "/submit/user_api_key", {
        data: filteredApiKeys,
      });
      if (response.status === 400) {
        sweetAlert("Error", response.message, "error");
        return;
      }
      // reset all the rows
      sweetAlert("Success", "Api Keys added successfully", "success");
      const newRows = [...rows];
      const newArray = newRows.map((row) => {
        return {
          apiKey: "",
          dailyLimit: "",
          engine: "",
        };
      });
      setRows(newArray);
      getApiKey();
    } catch (error) {
      console.log(error);
    }
  };

  const submitForm2 = async () => {
    try {
      // Filter out empty rows
      const filteredApiKeys = rows2.filter(
        (apiKey) => apiKey.apiKey !== "" || apiKey.secret !== "",
      );
      // give error if any row is incomplete
      const incompleteRows = filteredApiKeys.filter(
        (apiKey) => apiKey.apiKey === "" || apiKey.secret === "",
      );
      if (incompleteRows.length > 0) {
        // setError("Error: Please enter complete row");
        sweetAlert("Error", "Please enter complete row", "error");
        return;
      }
      // give error if no api keys are entered
      if (filteredApiKeys.length === 0) {
        // setError("Error: Please enter at least one complete row");
        sweetAlert("Error", "Please enter at least one complete row", "error");
        return;
      }
      const url = getAPIUrlBM();
      const response = await Post(url + "/submit/user_moj_api_key", {
        data: filteredApiKeys,
      });
      if (response.status === 400) {
        sweetAlert("Error", response.message, "error");
        return;
      }
      // reset all the rows
      sweetAlert("Success", "Api Keys added successfully", "success");
      const newRows = [...rows2];
      const newArray = newRows.map((row) => {
        return {
          apiKey: "",
          secret: "",
          token: "",
        };
      });
      setRows2(newArray);
      getApiKey2();
    } catch (error) {
      console.log(error);
    }
  };

  const submitForm3 = async () => {
    try {
      // Filter out empty rows
      const filteredApiKeys = rows3.filter((apiKey) => apiKey.token !== "");

      console.log("moz tokens", filteredApiKeys);

      // give error if no api keys are entered
      if (filteredApiKeys.length === 0) {
        // setError("Error: Please enter at least one complete row");
        sweetAlert("Error", "Please enter at least one row", "error");
        return;
      }

      const url = getAPIUrlBM();
      const response = await Post(url + "/submit/user_moj_api_key", {
        data: filteredApiKeys,
      });
      if (response.status === 400) {
        sweetAlert("Error", response.message, "error");
        return;
      }
      // reset all the rows
      sweetAlert("Success", "Moz Api Tokens added successfully", "success");
      const newRows = [...rows3];
      const newArray = newRows.map((row) => {
        return {
          apiKey: "",
          secret: "",
          token: "",
        };
      });
      setRows3(newArray);
      getApiKey2();
    } catch (error) {
      console.log(error);
    }
  };

  const addRow = () => {
    setRows([...rows, { apiKey: "", dailyLimit: "", engine: "" }]);
  };

  const addRow2 = () => {
    setRows([...rows2, { apiKey: "", secret: "" }]);
  };

  // const handleApiKeyChange = (event, index) => {
  //   const newRows = [...rows];
  //   newRows[index].apiKey = event.target.value;
  //   setRows(newRows);
  //   handleInputChange(event, index);
  // };

  const [error, setError] = useState("");
  const [error2, setError2] = useState("");

  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const newRows = [...rows];
    newRows[index][name] = value;
    setRows(newRows);

    // runtime validation to check for duplicate values
    let allKeys = newRows.map((row) => row.apiKey.trim());
    // delete all the empty values
    allKeys = allKeys.filter((key) => key !== "");
    // const allLimits = newRows.map((row) => row.dailyLimit.trim());
    if (allKeys.length > new Set(allKeys).size) {
      setError("Error: Rows cannot have the same value");
    } else {
      setError("");
    }
  };
  const handleInputChange2 = (e, index) => {
    const { name, value } = e.target;
    const newRows = [...rows2];
    newRows[index][name] = value;
    setRows2(newRows);

    // runtime validation to check for duplicate values
    let allKeys = newRows.map((row) => row.secret.trim());
    // delete all the empty values
    allKeys = allKeys.filter((key) => key !== "");
    // const allLimits = newRows.map((row) => row.dailyLimit.trim());
    if (allKeys.length > new Set(allKeys).size) {
      setError2("Error: Rows cannot have the same secret value");
    } else {
      setError2("");
    }
  };

  const handleInputChange3 = (e, index) => {
    const { name, value } = e.target;
    const newRows = [...rows3];
    newRows[index][name] = value;
    setRows3(newRows);

    // runtime validation to check for duplicate values
    let allKeys = newRows.map((row) => row.token.trim());
    // delete all the empty values
    allKeys = allKeys.filter((key) => key !== "");
    // const allLimits = newRows.map((row) => row.dailyLimit.trim());
    if (allKeys.length > new Set(allKeys).size) {
      setError2("Error: Rows cannot have the same token value");
    } else {
      setError2("");
    }
  };

  const saveEditDetails = async () => {
    try {
      const url = getAPIUrlBM();
      const response = await Put(url + "/update/user_api_key", {
        apiKey: edit.apiKey,
        engine: edit.engine,
        dailyLimit: edit.dailyLimit,
        id: edit.id,
      });
      console.log(response, "Ankur is coming");
      if (response.status === 200) {
        sweetAlert("Success", "Api Keys updated successfully", "success");
        getApiKey();
        document.getElementById("user_api_key_" + edit.id).style.display =
          "none";
      } else if (response.status === 400) {
        sweetAlert("Error", response.message, "error");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const saveEditDetails2 = async () => {
    try {
      const url = getAPIUrlBM();
      console.log(edit2, "edit");
      // return;
      const response = await Put(url + "/update/user_moj_api_key", {
        apiKey: edit2.apiKey,
        secret: edit2.secret,
        token: edit2.token,
        id: edit2.id,
      });
      console.log(response, "Ankur is coming");
      if (response.status === 200) {
        sweetAlert("Success", "Api Keys updated successfully", "success");
        getApiKey2();
        document.getElementById("user_moj_api_key_" + edit2.id).style.display =
          "none";
      } else if (response.status === 400) {
        sweetAlert("Error", response.message, "error");
      }
    } catch (error) {
      console.log(error);
    }
  };
  // const handleDailyLimitChange = (event, index) => {
  //   const newRows = [...rows];
  //   newRows[index].dailyLimit = event.target.value;
  //   setRows(newRows);
  // };
  const [edit, setEdit] = useState({});
  const handleInputChangeInEditMode = (e, index) => {
    const { name, value } = e.target;
    console.log(name, value, "Ankur is coming");
    setEdit({ ...edit, [name]: value });
  };

  const handleInputChangeInEditMode2 = (e, index) => {
    const { name, value } = e.target;
    console.log(name, value, "Ankur is coming");
    setEdit2({ ...edit2, [name]: value });
  };

  const handleClick = async (id, secret, token) => {
    try {
      window
        .sweet({
          title: "Are you sure?",
          text: "Once deleted, you will not be able to recover this api key!",
          icon: "warning",
          buttons: true,
        })
        .then(async (willDelete) => {
          if (!willDelete) {
            window.sweet({
              title: "Cancelled",
              text: "Your api key is safe",
              icon: "success",
            });
            return;
          }
          const url = getAPIUrlBM();
          const response = await Delete(url + "/delete/user_api_key", {
            id: id,
            secret: secret,
            token: token,
          });
          if (response.status === 400) {
            sweetAlert("Error", response.message, "error");
            return;
          }
          // reset all the rows
          sweetAlert("Success", "Api Keys deleted successfully", "success");
          getApiKey2();
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleClick2 = async (id, apiKey) => {
    try {
      window
        .sweet({
          title: "Are you sure?",
          text: "Once deleted, you will not be able to recover this api key!",
          icon: "warning",
          buttons: true,
        })
        .then(async (willDelete) => {
          if (!willDelete) {
            window.sweet({
              title: "Cancelled",
              text: "Your api key is safe",
              icon: "success",
            });
            return;
          }
          const url = getAPIUrlBM();
          const response = await Delete(url + "/delete/user_google_api_key", {
            id: id,
            secret: apiKey,
          });
          if (response.status === 400) {
            sweetAlert("Error", response.message, "error");
            return;
          }
          // reset all the rows
          sweetAlert("Success", "Api Keys deleted successfully", "success");
          getApiKey2();
        });
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
      }}
    >
      <Helmet>
        <title>AddUserApiKey - Backlink Checker</title>
        <meta
          name="description"
          content="You can add API keys to check if your backlinks are indexed in Google."
        />
        {/* <meta property="og:url" content="https://app.linkly.digital/lists" /> */}
        <link rel="icon" type="image/png" href={favicon} sizes="16x16" />
        <meta property="og:title" content="AddUserApiKey - Backlink Checker" />
        <meta
          property="og:description"
          content="You can add API keys to check if your backlinks are indexed in Google."
        />
        {/* <meta property="og:image" key="og:image" content={"/og_backLink.jpg"} /> */}
      </Helmet>

      <RouteChecker url="userApiKeyScreen">
        <Headers
          header={{
            heading: "Add Api Keys",
            link:
              tab === 1
                ? "https://www.loom.com/share/4e40a321245143b1bd25760d4cbce35b"
                : "https://www.loom.com/share/7f338c16d3314cdcb25572ce0249414e",
            isSubHeading: false,
            howItWorks:
              tab === 1
                ? "How index checking works with Google Index API ?"
                : "How we discover backlinks with Moz API ?",
          }}
        />
        <div className="tabSection">
          <div
            className={`tab ${tab === 1 ? "tabActive" : ""}`}
            onClick={() => {
              setTab(1);
            }}
          >
            Google Search Api Key <span> ( for index checking ) </span>
          </div>
          <div
            className={`tab ${tab === 2 ? "tabActive" : ""}`}
            onClick={() => {
              setTab(2);
            }}
          >
            Moz Api Key <span> ( for discovering backlinks ) </span>
          </div>
        </div>

        {tab === 1 ? (
          <>
            <div className="">
              <div className="flex-container-header">
                <span>Api Key Dashboard</span>
              </div>
              <div className="flex-container">
                <div className="flex-items flex-items-header">Api Keys</div>
                <div className="flex-items flex-items-header">Engine Id</div>
                <div className="flex-items flex-items-header">Daily Limit</div>
                <div className="flex-items flex-items-header">Used Limit</div>
                <div className="flex-items flex-items-header">Error Code</div>
                <div className="flex-items flex-items-header">Edit</div>
                <div className="flex-items flex-items-header">Delete</div>
              </div>
              {userApiKeys?.map((userApiKey, index) => {
                return (
                  <>
                    <div className="flex-container">
                      <div className="flex-items">{userApiKey.api_key}</div>
                      <div className="flex-items">{userApiKey.engine}</div>
                      <div className="flex-items">
                        {userApiKey.daily_limit ?? "----"}
                      </div>
                      <div className="flex-items">
                        {userApiKey.used_limit ?? "----"}
                      </div>
                      <div className="flex-items">
                        {userApiKey.error_code ?? "----"}
                      </div>
                      <div
                        className="flex-items"
                        onClick={() => {
                          if (
                            "user_api_key_" + edit?.id !==
                              "user_api_key_" + userApiKey.id &&
                            edit.id
                          ) {
                            document.getElementById(
                              "user_api_key_" + edit.id,
                            ).style.display = "none";
                          }

                          document.getElementById(
                            "user_api_key_" + userApiKey.id,
                          ).style.display =
                            document.getElementById(
                              "user_api_key_" + userApiKey.id,
                            ).style.display === "none"
                              ? "flex"
                              : "none";

                          setEdit(() => {
                            return {
                              apiKey: userApiKey.api_key,
                              engine: userApiKey.engine,
                              dailyLimit: userApiKey.daily_limit,
                              id: userApiKey.id,
                            };
                          });
                        }}
                      >
                        {/* <img
                            src="../../../editIcon.png"
                            width={20}
                            alt=""
                            height={20}
                          />{" "} */}
                        <EditIcon />
                      </div>
                      <div className="flex-items">
                        <button
                          className="btn btn-danger font-weight-bold"
                          onClick={() => {
                            handleClick2(userApiKey.id, userApiKey.api_key);
                          }}
                        >
                          Delete
                        </button>
                      </div>
                    </div>
                    {
                      <div
                        className="flex-container"
                        style={{
                          display: "none",
                        }}
                        id={"user_api_key_" + userApiKey.id}
                      >
                        <div className="flex-items">
                          <input
                            type="text"
                            name="apiKey"
                            defaultValue={userApiKey.api_key}
                            onChange={(e) => {
                              handleInputChangeInEditMode(e, index);
                            }}
                          />
                        </div>
                        <div className="flex-items">
                          <input
                            type="text"
                            name="engine"
                            defaultValue={userApiKey.engine}
                            onChange={(e) => {
                              handleInputChangeInEditMode(e, index);
                            }}
                          />
                        </div>
                        <div className="flex-items">
                          <input
                            type="text"
                            name="dailyLimit"
                            defaultValue={userApiKey.daily_limit}
                            onChange={(e) => {
                              handleInputChangeInEditMode(e, index);
                            }}
                          />
                        </div>
                        <div className="flex-items">
                          {/* {userApiKey.used_limit ?? "----"} */}
                        </div>
                        <div className="flex-items">
                          {/* {userApiKey.error ?? "----"} */}
                        </div>
                        <div className="flex-items flex-items-button">
                          {/* <button>Save</button>
                        <button>Cancel</button> */}
                          <button
                            className="pl-3 pr-3 pt-2 pb-2"
                            onClick={saveEditDetails}
                          >
                            Save
                          </button>
                          <button
                            className="pl-3 pr-3 pt-2 pb-2"
                            onClick={() => {
                              document.getElementById(
                                "user_api_key_" + userApiKey.id,
                              ).style.display =
                                document.getElementById(
                                  "user_api_key_" + userApiKey.id,
                                ).style.display === "none"
                                  ? "flex"
                                  : "none";
                              window.sweet({
                                text: "Changes Discarded",
                                icon: "success",
                              });
                            }}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    }
                  </>
                );
              })}
            </div>
            <div className="api-key-form-container">
              <div
                className="flex-container-header"
                style={{
                  marginBottom: "0",
                }}
              >
                <span>Add Api Keys</span>
              </div>

              <span
                style={{
                  color: "#3f51b5",
                  cursor: "pointer",
                  marginBottom: "10px",
                }}
                onClick={() => {
                  window.open(
                    "http://links.backlinkchecker.info/api-keys",
                    "_blank",
                  );
                }}
              >
                How to find Google Customer Search API key?
              </span>
              <table className="api-key-table">
                <thead>
                  <tr>
                    <th className="api-key-header">API Key</th>
                    <th className="daily-limit-header">Engine Id</th>
                    <th className="daily-limit-header">Daily Limit</th>
                  </tr>
                </thead>
                <tbody>
                  {rows?.map((row, index) => (
                    <tr key={index} className="tr-in-table">
                      <td className="api-key-input-td">
                        <input
                          className="api-key-input"
                          type="text"
                          value={row.apiKey}
                          name="apiKey"
                          onChange={(event) => handleInputChange(event, index)}
                        />
                      </td>
                      <td className="engine-input-td">
                        <input
                          className="daily-limit-input"
                          type="text"
                          name="engine"
                          value={row.engine}
                          onChange={(event) => handleInputChange(event, index)}
                        />
                      </td>
                      <td className="daily-limit-input-td">
                        <input
                          className="daily-limit-input"
                          type="number"
                          name="dailyLimit"
                          value={row.dailyLimit}
                          onChange={(event) => handleInputChange(event, index)}
                        />
                      </td>
                    </tr>
                  ))}
                  {error && (
                    <tr className="error-message">
                      <td colSpan={3}>{error}</td>
                    </tr>
                  )}
                </tbody>
              </table>
              {
                <button className="add-row-button" onClick={addRow}>
                  +
                </button>
              }

              <button className="save-button" onClick={submitForm}>
                Save
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="">
              <div className="flex-container-header">
                <span>Moz Api Key Dashboard</span>
              </div>
              <div className="flex-container-2">
                <div className="flex-items-2 flex-items-header">Access Id</div>
                <div className="flex-items-2 flex-items-header">Secret Key</div>
                {/* <div className="flex-items-2 flex-items-header">Daily Limit</div>
              <div className="flex-items-2 flex-items-header">Used Limit</div> */}
                <div className="flex-items-2 flex-items-header">Error Code</div>
                <div className="flex-items-2 flex-items-header">Edit</div>
                <div className="flex-items-2 flex-items-header">Delete</div>
              </div>
              {userMojApiKeys.filter(
                (item) => item.apiKey !== "" && item.secret !== "",
              ).length == 0 && (
                <div style={{ textAlign: "center" }}>No entries</div>
              )}
              {userMojApiKeys?.map((userApiKey, index) => {
                if (userApiKey.api_key && userApiKey.secret) {
                  return (
                    <>
                      <div className="flex-container-2">
                        <div className="flex-items-2">{userApiKey.api_key}</div>
                        <div className="flex-items-2">{userApiKey.secret}</div>
                        {/* <div className="flex-items">
                      {userApiKey.used_limit ?? "----"}
                    </div>
                    <div className="flex-items">
                      {userApiKey.used_limit ?? "----"}
                    </div> */}
                        <div className="flex-items-2">
                          {userApiKey.error ?? "----"}
                        </div>
                        <div
                          className="flex-items-2 align-items-center align-content-center"
                          onClick={() => {
                            if (
                              "user_moj_api_key_" + edit2?.id !==
                                "user_moj_api_key_" + userApiKey.id &&
                              edit2.id
                            ) {
                              document.getElementById(
                                "user_moj_api_key_" + edit2.id,
                              ).style.display = "none";
                            }

                            document.getElementById(
                              "user_moj_api_key_" + userApiKey.id,
                            ).style.display =
                              document.getElementById(
                                "user_moj_api_key_" + userApiKey.id,
                              ).style.display === "none"
                                ? "flex"
                                : "none";

                            setEdit2(() => {
                              return {
                                apiKey: userApiKey.api_key,
                                secret: userApiKey.secret,
                                token: userApiKey.token,
                                id: userApiKey.id,
                              };
                            });
                          }}
                        >
                          {/* <img
                            src="../../../editIcon.png"
                            width={20}
                            alt=""
                            height={20}
                          />{" "} */}
                          <EditIcon />
                        </div>
                        <div className="flex-items-2">
                          <button
                            className="btn btn-danger font-weight-bold"
                            onClick={() =>
                              handleClick(
                                userApiKey.id,
                                userApiKey.secret,
                                userApiKey.token,
                              )
                            }
                          >
                            Delete
                          </button>
                        </div>
                      </div>
                      {
                        <div
                          className="flex-container"
                          style={{
                            display: "none",
                          }}
                          id={"user_moj_api_key_" + userApiKey.id}
                        >
                          <div className="flex-items">
                            <input
                              type="text"
                              name="apiKey"
                              defaultValue={userApiKey.api_key}
                              onChange={(e) => {
                                handleInputChangeInEditMode2(e, index);
                              }}
                            />
                          </div>
                          <div className="flex-items">
                            <input
                              type="text"
                              name="secret"
                              defaultValue={userApiKey.secret}
                              onChange={(e) => {
                                handleInputChangeInEditMode2(e, index);
                              }}
                            />
                          </div>
                          {/* <div className="flex-items">
                        <input
                          type="text"
                          name="dailyLimit"
                          defaultValue={userApiKey.daily_limit}
                          onChange={(e) => {
                            handleInputChangeInEditMode(e, index);
                          }}
                        />
                      </div>
                      <div className="flex-items">
                        {userApiKey.used_limit ?? "----"}
                      </div> */}
                          <div className="flex-items">
                            {userApiKey.error ?? "----"}
                          </div>
                          <div className="flex-items flex-items-button">
                            <button
                              className="pl-3 pr-3 pt-2 pb-2"
                              onClick={saveEditDetails2}
                            >
                              Save
                            </button>
                            <button
                              className="pl-3 pr-3 pt-2 pb-2"
                              onClick={() => {
                                document.getElementById(
                                  "user_moj_api_key_" + userApiKey.id,
                                ).style.display =
                                  document.getElementById(
                                    "user_moj_api_key_" + userApiKey.id,
                                  ).style.display === "none"
                                    ? "flex"
                                    : "none";
                                window.sweet({
                                  text: "Changes Discarded",
                                  icon: "success",
                                });
                              }}
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      }
                    </>
                  );
                }
              })}
              <br />
              <div className="flex-container-2">
                <div className="flex-items-2 flex-items-header">
                  Moz api token
                </div>
                {/* <div className="flex-items-2 flex-items-header">Daily Limit</div>
              <div className="flex-items-2 flex-items-header">Used Limit</div> */}
                <div className="flex-items-2 flex-items-header">Error Code</div>
                <div className="flex-items-2 flex-items-header">Edit</div>
                <div className="flex-items-2 flex-items-header">Delete</div>
              </div>
              {userMojApiKeys.filter(
                (item) => item.token !== null && item.token !== "",
              ).length == 0 && (
                <div style={{ textAlign: "center" }}>No entries</div>
              )}
              {userMojApiKeys?.map((userApiKey, index) => {
                if (userApiKey.token) {
                  return (
                    <>
                      <div className="flex-container-2">
                        <div className="flex-items-2">{userApiKey.token}</div>
                        {/* <div className="flex-items">
                      {userApiKey.used_limit ?? "----"}
                    </div>
                    <div className="flex-items">
                      {userApiKey.used_limit ?? "----"}
                    </div> */}
                        <div className="flex-items-2">
                          {userApiKey.error ?? "----"}
                        </div>
                        <div
                          className="flex-items-2 align-items-center align-content-center"
                          onClick={() => {
                            if (
                              "user_moj_api_key_" + edit2?.id !==
                                "user_moj_api_key_" + userApiKey.id &&
                              edit2.id
                            ) {
                              document.getElementById(
                                "user_moj_api_key_" + edit2.id,
                              ).style.display = "none";
                            }

                            document.getElementById(
                              "user_moj_api_key_" + userApiKey.id,
                            ).style.display =
                              document.getElementById(
                                "user_moj_api_key_" + userApiKey.id,
                              ).style.display === "none"
                                ? "flex"
                                : "none";

                            setEdit2(() => {
                              return {
                                apiKey: userApiKey.api_key,
                                secret: userApiKey.secret,
                                token: userApiKey.token,
                                id: userApiKey.id,
                              };
                            });
                          }}
                        >
                          {/* <img
                            src="../../../editIcon.png"
                            width={20}
                            alt=""
                            height={20}
                          />{" "} */}
                          <EditIcon />
                        </div>
                        <div className="flex-items-2">
                          <button
                            className="btn btn-danger font-weight-bold"
                            onClick={() =>
                              handleClick(
                                userApiKey.id,
                                userApiKey.secret,
                                userApiKey.token,
                              )
                            }
                          >
                            Delete
                          </button>
                        </div>
                      </div>
                      {
                        <div
                          className="flex-container"
                          style={{
                            display: "none",
                          }}
                          id={"user_moj_api_key_" + userApiKey.id}
                        >
                          <div className="flex-items">
                            <input
                              type="text"
                              name="token"
                              defaultValue={userApiKey.token}
                              onChange={(e) => {
                                handleInputChangeInEditMode2(e, index);
                              }}
                            />
                          </div>
                          {/* <div className="flex-items">
                        <input
                          type="text"
                          name="dailyLimit"
                          defaultValue={userApiKey.daily_limit}
                          onChange={(e) => {
                            handleInputChangeInEditMode(e, index);
                          }}
                        />
                      </div>
                      <div className="flex-items">
                        {userApiKey.used_limit ?? "----"}
                      </div> */}
                          <div className="flex-items">
                            {userApiKey.error ?? "----"}
                          </div>
                          <div className="flex-items flex-items-button">
                            <button
                              className="pl-3 pr-3 pt-2 pb-2"
                              onClick={saveEditDetails2}
                            >
                              Save
                            </button>
                            <button
                              className="pl-3 pr-3 pt-2 pb-2"
                              onClick={() => {
                                document.getElementById(
                                  "user_moj_api_key_" + userApiKey.id,
                                ).style.display =
                                  document.getElementById(
                                    "user_moj_api_key_" + userApiKey.id,
                                  ).style.display === "none"
                                    ? "flex"
                                    : "none";
                                window.sweet({
                                  text: "Changes Discarded",
                                  icon: "success",
                                });
                              }}
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      }
                    </>
                  );
                }
              })}
            </div>
            <div className="api-key-form-container">
              <div className="flex-container-header">
                <span>Add Moz Api Keys</span>
              </div>
              <span>
                For users before mar 2024 secret key and access id works fine
                otherwise use moz api token
              </span>
              <br />
              <span
                style={{
                  color: "#3f51b5",
                  cursor: "pointer",
                  marginBottom: "10px",
                }}
                onClick={() => {
                  window.open(
                    "https://backlinkchecker.tawk.help/article/is-moz-api-free-to-use",
                    "_blank",
                  );
                }}
              >
                Is Moz API key free ?
              </span>
              <Stack direction="row" spacing={1} alignItems="center">
                <Typography>Moz Api Token</Typography>
                <Switch
                  checked={checked}
                  onChange={handleChange}
                  inputProps={{ "aria-label": "controlled" }}
                />
                <Typography>Access Id and Secret Key</Typography>
              </Stack>
              {checked ? (
                <>
                  <table className="api-key-table">
                    <thead>
                      <tr>
                        <th className="api-key-header">Access Id</th>
                        <th className="daily-limit-header">Secret Key</th>
                        {/* <th className="daily-limit-header">Daily Limit</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {rows2?.map((row, index) => (
                        <tr key={index} className="tr-in-table">
                          <td className="api-key-input-td">
                            <input
                              className="api-key-input"
                              type="text"
                              value={row.apiKey}
                              name="apiKey"
                              onChange={(event) =>
                                handleInputChange2(event, index)
                              }
                            />
                          </td>
                          <td className="engine-input-td">
                            <input
                              className="daily-limit-input"
                              type="text"
                              name="secret"
                              value={row.secret}
                              onChange={(event) =>
                                handleInputChange2(event, index)
                              }
                            />
                          </td>
                          {/* <td className="daily-limit-input-td">
                      <input
                        className="daily-limit-input"
                        type="number"
                        name="dailyLimit"
                        value={row.dailyLimit}
                        onChange={(event) => handleInputChange2(event, index)}
                      />
                    </td> */}
                        </tr>
                      ))}
                      {error2 && (
                        <tr className="error-message">
                          <td colSpan={3}>{error2}</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  {
                    <button className="add-row-button" onClick={addRow2}>
                      +
                    </button>
                  }

                  <button className="save-button" onClick={submitForm2}>
                    Save
                  </button>
                </>
              ) : (
                <>
                  <table className="api-key-table">
                    <thead>
                      <tr>
                        <th className="moz-token">Moz Api Token</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rows3?.map((row, index) => (
                        <tr key={index} className="tr-in-table">
                          <td className="api-key-input-td">
                            <input
                              className="api-key-input"
                              type="text"
                              value={row.token}
                              name="token"
                              onChange={(event) =>
                                handleInputChange3(event, index)
                              }
                            />
                          </td>
                        </tr>
                      ))}
                      {error2 && (
                        <tr className="error-message">
                          <td colSpan={3}>{error2}</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  {
                    <button className="add-row-button" onClick={addRow2}>
                      +
                    </button>
                  }

                  <button className="save-button" onClick={submitForm3}>
                    Save
                  </button>
                </>
              )}
            </div>
          </>
        )}
      </RouteChecker>
    </div>
  );
}

export default AddUserApiKey;
